import { Skeleton } from "@mui/material";
import { DDD, E2Data } from "../../lib/ddd/ddd";
import classes from "./DashboardComponents.module.scss";
import { useQuery } from "@tanstack/react-query";
import { useContext, useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { OrgIdContext, Domain } from "../../store/orgId_context";
import ButtonLink from "../UI/ButtonLink";
import { useTranslation } from 'react-i18next';

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const e2Data = new E2Data("EU_AOrg_Packages");
e2Data.format = "Full";


const CurrentPackages = () => {
    const {sessionInfo, domain} = useContext(OrgIdContext);
    const [IEIPackage, setIEIPackage] = useState();
    const [REIPackage, setREIPackage] = useState();
    const [fiscPackage, setFiscPackage] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslation();
    //let isLoading=true;

    useEffect(() => {
        setIEIPackage(sessionInfo?.Extended?.CurrentPackages?.IEI_Package)
        setREIPackage(sessionInfo?.Extended?.CurrentPackages?.REI_Package)
        setFiscPackage(sessionInfo?.Extended?.CurrentPackages?.FISC_Package)
    },[sessionInfo]);
    /*const {isPending : isLoading, data : packagesData} = useQuery({
        queryKey: ['Data.GetEntityData', e2Data.GetParamsObject()],
        queryFn: () => e2Data.GetData(),
        staleTime: "Infinity"
    });

    useEffect(() => {
        if(!packagesData || isLoading)
            return;

        const packages = packagesData.result?.data || [];
        for(const p of packages){
            if(p.CurrentPackageType === "IEI")
                setIEIPackage(p);
            if(p.CurrentPackageType === "REI")
                setREIPackage(p);
            if(p.CurrentPackageType === "FISC")
                setFiscPackage(p);
        }
    }, [packagesData, isLoading]);*/

    return (<>
    <div className={classes.container}>
    <Row>
        <Col>
            <h2 className={`mb-3 ${classes.subtitle}`}>{t("Current Packages")}</h2>
        </Col>
    </Row>
    <Row style={{marginBottom:"2px"}}>
        <Col className="col-12 col-md-8">
            {t("Issued invoices")}:
            <p className={classes.package} style={{margin:"0px"}}>
                {isLoading && <Skeleton/>}
                {!isLoading && !IEIPackage && <>
                    {t("None")}
                </>}
                {IEIPackage && <>
                    {IEIPackage.PackageCode} (
                        {IEIPackage.Trial && <>
                            {t("Days left")}:{IEIPackage.CurrentValidTo != null && <>{IEIPackage.ValidDaysLeft}</>}
                        </>}

                        {!IEIPackage.Trial && <>
                            {IEIPackage.PayType === "Monthly" && <>{IEIPackage.PricePerMonth}€/{t("month")}</>}
                            {IEIPackage.PayType !== "Monthly" && <>{IEIPackage.PricePerYear}€/{t("year")}</>}
                        </>}
                    )
                </>}
            </p>
        </Col>
        <Col className="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-start mb-3 mb-md-0">
            {isLoading && <Skeleton style={{width:"100%"}}/>}
            {!isLoading && <ButtonLink href="/packages?forservice=iei" className="px-4 py-1" style={{fontSize:"0.8rem"}}>
                {IEIPackage && <>{t("Change plan")}</>}
                {!IEIPackage && <>
                    {t("Select plan")}
                </>}
            </ButtonLink>}
        </Col>
    </Row>
    <Row style={{marginBottom:"2px"}}>
        <Col className="col-12 col-md-8">
            {t("Received Invoices")}:
            <p className={classes.package} style={{margin:"0px"}}>
                {isLoading && <Skeleton/>}
                {!isLoading && !REIPackage && <>
                    {t("None")}
                </>}
                {REIPackage && <>
                    {REIPackage.PackageCode} (
                        {REIPackage.Trial && <>
                            {t("Days left")}:{REIPackage.CurrentValidTo != null && <>{REIPackage.ValidDaysLeft}</>}
                        </>}
                        {!REIPackage.Trial && <>
                            {REIPackage.PayType === "Monthly" && <>{REIPackage.PricePerMonth}€/{t("month")}</>}
                            {REIPackage.PayType !== "Monthly" && <>{REIPackage.PricePerYear}€/{t("year")}</>}
                        </>}
                    )
                </>}
            </p>
        </Col>
        <Col className="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-start mb-3 mb-md-0">
            {isLoading && <Skeleton style={{width:"100%"}}/>}
            {!isLoading && <ButtonLink href="/packages?forservice=rei" className="px-4 py-1" style={{fontSize:"0.8rem"}}>
                {REIPackage && <>{t("Change plan")}</>}
                {!REIPackage && <>
                    {t("Select plan")}
                </>}
            </ButtonLink>}
        </Col>
    </Row>
    {sessionInfo.Extended.IsFiscalization && domain === Domain.DDDInvoices && 
    <Row>
        <Col className="col-12 col-md-8">
            {t("Fiscalization")}:
            <p className={classes.package} style={{margin:"0px"}}>
                {isLoading && <Skeleton/>}
                {!isLoading && !fiscPackage && <>
                    {t("None")}
                </>}
                {fiscPackage && <>
                    {fiscPackage.PackageCode} (
                        {fiscPackage.Trial && <>
                            {t("Days left")}:{fiscPackage.CurrentValidTo != null && <>{fiscPackage.ValidDaysLeft}</>}
                        </>}
                        {!fiscPackage.Trial && <>
                            {fiscPackage.PayType === "Monthly" && <>{fiscPackage.PricePerMonth}€/{t("month")}</>}
                            {fiscPackage.PayType !== "Monthly" && <>{fiscPackage.PricePerYear}€/{t("year")}</>}
                        </>}
                    )
                </>}
            </p>
        </Col>
        <Col className="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-start mb-3 mb-md-0">
            {isLoading && <Skeleton style={{width:"100%"}}/>}
            {!isLoading && <ButtonLink href="/packages?forservice=fisc" className="px-4 py-1" style={{fontSize:"0.8rem"}}>
                {fiscPackage && <>{t("Change plan")}</>}
                {!fiscPackage && <>
                    {t("Select plan")}
                </>}
            </ButtonLink>}
        </Col>
    </Row>}
    {/* <Row>
        <Col className="col-12 col-md-6">
          <p className={classes.package}>
            {isLoading!==false && <Skeleton/>}
            {isLoading!==false && <Skeleton/>}
            {isLoading!==false && sessionInfo.IsFiscalization && <Skeleton/>}
            {!isLoading && (<>
              {data?.CurrentPackageName} ({data?.CurrentPackageCode})
              <div>Sending invoices:</div>
              Received Invoices:
              Fiscalization:
            </>)}
          </p>
        </Col>
        <Col className="col-12 col-md-6 d-flex align-items-center justify-content-center justify-content-md-start mb-3 mb-md-0">
          <ButtonLink href="/change-payment-plan" className="px-4 py-1">
            Change plan
          </ButtonLink>
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-6">
          <p>
            Payment frequency:{" "}
            <span className={classes.key}>
              {data?.CurrentPackagePayType?.toLowerCase() || <Skeleton/>}
            </span>
          </p>
        </Col>
        <Col className="col-12 col-md-6">
            <span className={classes.key}><Skeleton/></span>
        </Col>
      </Row> */}
    </div>
    </>);
}

export default CurrentPackages;